import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { ArrowRight } from "lucide-react";
import Logo from "../components/Logo";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(email, password, name);
      nav("/profile");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-8">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-10">
          <Logo size={36} />
          <div className="text-xl font-black tracking-tighter">VIZIONCAST</div>
        </div>
        <div className="text-xs tracking-[0.25em] uppercase text-[#0033FF] font-bold mb-3">Get started</div>
        <h1 className="text-4xl font-black tracking-tighter mb-2">Start casting your vision.</h1>
        <p className="text-sm text-zinc-600 mb-8">A few clicks and VizionCast is ready to cast your vision.</p>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="text-[10px] tracking-[0.25em] uppercase font-bold text-zinc-600">Your name</label>
            <input data-testid="register-name-input" type="text" value={name} onChange={(e)=>setName(e.target.value)} required
              className="w-full mt-2 px-3 py-3 border border-zinc-300 focus:outline-none focus:border-[#0033FF]"/>
          </div>
          <div>
            <label className="text-[10px] tracking-[0.25em] uppercase font-bold text-zinc-600">Email</label>
            <input data-testid="register-email-input" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required
              className="w-full mt-2 px-3 py-3 border border-zinc-300 focus:outline-none focus:border-[#0033FF]"/>
          </div>
          <div>
            <label className="text-[10px] tracking-[0.25em] uppercase font-bold text-zinc-600">Password</label>
            <input data-testid="register-password-input" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required minLength={6}
              className="w-full mt-2 px-3 py-3 border border-zinc-300 focus:outline-none focus:border-[#0033FF]"/>
          </div>
          {err && <div data-testid="register-error" className="text-sm text-[#FF3B30] border-l-2 border-[#FF3B30] pl-3 py-1">{err}</div>}
          <button data-testid="register-submit-btn" disabled={loading}
            className="w-full bg-[#0033FF] text-white px-4 py-3.5 text-sm font-bold tracking-wider uppercase hover:bg-zinc-900 disabled:opacity-50 flex items-center justify-center gap-2">
            {loading ? "Creating account…" : <>Create account <ArrowRight className="w-4 h-4" /></>}
          </button>
        </form>
        <div className="mt-8 text-sm text-zinc-600">
          Have an account? <Link to="/login" data-testid="goto-login" className="font-bold text-zinc-900 underline underline-offset-4">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
